import { useContext, useLayoutEffect } from "react";
import { AppContext } from "../contexts/AppContext";
import palette from "../palette.json";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Socials from "./Socials";

const Layout = ({ children }) => {
    const { colorIndex } = useContext(AppContext);
    const accent = palette[colorIndex];

    // Set the accent on the root element so the page background and the mobile
    // browser bar pick it up too, not only this component's children.
    useLayoutEffect(() => {
        document.documentElement.style.setProperty('--accent', accent);
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', accent);
    }, [accent]);

    return <div className={`min-h-[100dvh] md:h-[100dvh] flex p-2 sm:p-4 md:p-6`}>
        <div className={`bg-base text-slate-200 rounded-xl shadow-2xl flex flex-col w-full md:min-h-0 px-5 pt-6 pb-8 sm:px-8 sm:pt-8 md:pb-4 lg:px-12 lg:pt-10`}>
            <Navbar />
            <div className={`h-px w-full shrink-0 bg-accent opacity-70 mt-5 mb-6 sm:mt-6 md:mb-8 transition-colors duration-700`}></div>
            <div className={`flex flex-col md:flex-row flex-1 md:min-h-0 gap-6 md:gap-10 lg:gap-16`}>
                <Sidebar />
                <main className={`flex flex-1 min-w-0 md:min-h-0`}>
                    {children}
                </main>
            </div>
            {/* Narrow screens: a footnote at the end of the page. */}
            <footer className={`md:hidden mt-12 pt-6 border-t border-white/10`}>
                <Socials className={`text-sm text-slate-500`} />
            </footer>
            {/* Wide screens: pinned to the bottom of the card, below the scrolling content. */}
            <footer className={`hidden md:flex shrink-0 justify-end pt-3 mt-2 border-t border-white/5`}>
                <Socials className={`text-xs tracking-wide text-slate-500`} />
            </footer>
        </div>
    </div>
}

export default Layout;
